export default __webpack_public_path__ + "static/1097-b8a8dc2e1ab43bb9b017d05d8d2aab6f.gif";